import { Outlet } from 'react-router-dom'

import { Admin, Auth, Report } from 'Components/Layout'
import { Lazy } from 'Components/Loader'

import Password from 'Components/FormGroup/Password'
import Signature from 'Components/FormGroup/Signature'

const admin = [
    {
        path: 'admin',
        element: <Auth guard="admin" />,
        children: [
            { path: 'verify-email', element: <Lazy view="Auth/VerifyEmail" /> },
            { path: 'verify-email/:id/:hash', element: <Lazy view="Auth/VerifyEmail" /> },
        ],
    },
    {
        path: 'admin',
        element: <Report guard="admin" />,
        children: [{ path: 'transformer-tests/:id/report', element: <Lazy view="Admin/TransformerTests/Report" /> }],
    },
    {
        path: 'admin',
        element: <Admin guard="admin" />,
        children: [
            { path: '', element: <Lazy view="Admin/Dashboard" /> },
            { path: 'profile', element: <Lazy view="Admin/Dashboard/Profile" /> },
            { path: 'password', element: <Password /> },
            { path: 'signature', element: <Signature /> },
            { path: 'login-history', element: <Lazy view="Admin/Dashboard/LoginHistory" title="Login History" /> },
            { path: 'setting', element: <Lazy view="Admin/Dashboard/Setting" title="Setting" /> },
            {
                path: 'admins',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/Admins/List" /> },
                    { path: 'create', element: <Lazy view="Admin/Admins/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/Admins/Create" title="Edit" /> },
                ],
            },
            {
                path: 'roles',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/Roles/List" /> },
                    { path: 'create', element: <Lazy view="Admin/Roles/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/Roles/Create" title="Edit" /> },
                ],
            },
            {
                path: 'users',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/Users/List" /> },
                    { path: 'create', element: <Lazy view="Admin/Users/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/Users/Create" title="Edit" /> },
                ],
            },
            {
                path: 'customers',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/Customers/List" /> },
                    { path: 'create', element: <Lazy view="Admin/Customers/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/Customers/Create" title="Edit" /> },
                ],
            },
            {
                path: 'inspectors',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/Inspectors/List" /> },
                    { path: 'create', element: <Lazy view="Admin/Inspectors/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/Inspectors/Create" title="Edit" /> },
                ],
            },
            {
                path: 'projects',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/Projects/List" /> },
                    { path: 'create', element: <Lazy view="Admin/Projects/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/Projects/Create" title="Edit" /> },
                ],
            },
            {
                path: 'transformers',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/Transformers/List" /> },
                    { path: 'create', element: <Lazy view="Admin/Transformers/Create" title="Add new" /> },
                    { path: ':id', element: <Lazy view="Admin/Transformers/View" title="View" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/Transformers/Create" title="Edit" /> },
                ],
            },
            {
                path: 'test-types',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/TestTypes/List" /> },
                    { path: 'create', element: <Lazy view="Admin/TestTypes/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/TestTypes/Create" title="Edit" /> },
                ],
            },
            {
                path: 'transformer-tests',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/TransformerTests/List" /> },
                    { path: 'create', element: <Lazy view="Admin/TransformerTests/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/TransformerTests/Create" title="Edit" /> },
                    { path: ':id/tests', element: <Lazy view="Admin/Tests/List" /> },
                    { path: ':id/tests/:test_id', element: <Lazy view="Admin/Tests/View" title="View" /> },
                    { path: ':id/tests/:test_id/edit', element: <Lazy view="Admin/Tests/Create" title="Apply" /> },
                    { path: ':id/reports', element: <Lazy view="Admin/TransformerTests/Reports" /> },
                ],
            },
            {
                path: 'feedbacks',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/Feedbacks/List" /> },
                    { path: 'create', element: <Lazy view="Admin/Feedbacks/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/Feedbacks/Create" title="Edit" /> },
                ],
            },
            {
                path: 'reports',
                element: <Outlet />,
                children: [
                    {
                        path: 'customer-satisfaction',
                        element: <Lazy view="Admin/Reports/CustomerSatisfaction" title="Customer Satisfaction" />,
                    },
                    {
                        path: 'monthly-customer-satisfaction',
                        element: <Lazy view="Admin/Reports/MonthlyCustomerSatisfaction" title="Monthly Satisfaction" />,
                    },
                    {
                        path: 'customer-comments',
                        element: <Lazy view="Admin/Reports/CustomerComments" title="Customer Comments" />,
                    },
                ],
            },
            {
                path: 'cooling-types',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/CoolingTypes/List" /> },
                    { path: 'create', element: <Lazy view="Admin/CoolingTypes/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/CoolingTypes/Create" title="Edit" /> },
                ],
            },
            {
                path: 'reference-standards',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/ReferenceStandards/List" /> },
                    { path: 'create', element: <Lazy view="Admin/ReferenceStandards/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/ReferenceStandards/Create" title="Edit" /> },
                ],
            },
            {
                path: 'winding-materials',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/WindingMaterials/List" /> },
                    { path: 'create', element: <Lazy view="Admin/WindingMaterials/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/WindingMaterials/Create" title="Edit" /> },
                ],
            },
            {
                path: 'equipments',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/Equipments/List" /> },
                    { path: 'create', element: <Lazy view="Admin/Equipments/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/Equipments/Create" title="Edit" /> },
                ],
            },
            {
                path: 'diagrams',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/Diagrams/List" /> },
                    { path: 'create', element: <Lazy view="Admin/Diagrams/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/Diagrams/Create" title="Edit" /> },
                ],
            },
            {
                path: 'lab-surface-areas',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/LabSurfaceAreas/List" /> },
                    { path: 'create', element: <Lazy view="Admin/LabSurfaceAreas/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/LabSurfaceAreas/Create" title="Edit" /> },
                ],
            },
        ],
    },
]

export default admin
